import { SPACE_UNIT_VALUE } from '../../constants/layout';
import type { SpacesObject } from './type';

export const getMarginsFromSpacesObject = (spaces: SpacesObject): string => {
  const top = (spaces.top || spaces.vertical || 0) * SPACE_UNIT_VALUE;
  const bottom = (spaces.bottom || spaces.vertical || 0) * SPACE_UNIT_VALUE;
  const left = (spaces.left || spaces.horizontal || 0) * SPACE_UNIT_VALUE;
  const right = (spaces.right || spaces.horizontal || 0) * SPACE_UNIT_VALUE;

  return `${top}px ${right}px ${bottom}px ${left}px`;
};
